import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "排行榜", to: "/ranking" },
  { label: "完结推荐", to: "/ranking?filter=completed" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/ranking?q=${encodeURIComponent(q)}` : "/ranking");
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/85 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2"
          aria-label="韩漫聚合阅读站首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-display text-xl text-foreground-950">
            韩漫<span className="text-primary-500">悦读</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-7 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) =>
                `whitespace-nowrap text-sm font-medium transition-colors hover:text-primary-500 ${
                  isActive && item.to.startsWith("/ranking")
                    ? "text-primary-500"
                    : "text-foreground-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop search + action */}
        <div className="hidden items-center gap-3 md:flex">
          <form
            onSubmit={submitSearch}
            className="flex items-center overflow-hidden rounded-full border border-background-300/80 bg-background-100 focus-within:border-primary-400"
          >
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索韩漫名称 / 题材"
              aria-label="搜索韩漫"
              className="h-9 w-44 bg-transparent px-4 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="flex h-9 w-10 shrink-0 items-center justify-center bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-line text-sm"></i>
            </button>
          </form>
          <Link
            to="/ranking"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-500"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <form onSubmit={submitSearch} className="mt-3 flex items-center overflow-hidden rounded-full border border-background-300 bg-background-100">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索韩漫名称 / 题材"
              aria-label="搜索韩漫"
              className="h-10 flex-1 bg-transparent px-4 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="flex h-10 w-12 shrink-0 items-center justify-center bg-primary-500 text-background-50"
            >
              <i className="ri-search-line text-sm"></i>
            </button>
          </form>
        </div>
      )}
    </header>
  );
}